// Externe Bibliotheken
import React, { Component } from 'react';

// Interne Module
import { checkIsAllowToBookService } from '@/_helper/checkAccess';
import * as storage from '@/_helper/storage';
import tracking from '@/_helper/tracking';

// Komponenten
import Header from '@/comp/header/header';
import Footer from '@/comp/footer/Footer';
import Form from './Form';
import HeroTeaser from '@/comp/heroTeaser';
import { DetectMultipleTabs } from '@/comp/multipleTabs/multipleTabs';

// Styles
import './transfer.scss';

class Index extends Component {
    componentDidMount() {
        document.title = 'Transfer' + window.$documentTitle;

        checkIsAllowToBookService('transfer');

        // transfer service : hotel serviceInformation not defined
        if (
            storage.get('bookingData') !== null &&
            storage.get('bookingData').data.serviceInformation !== undefined &&
            storage.get('bookingData').data.serviceInformation.hotel === undefined
        ) {
            window.location.href = '#/';
        }

        document.querySelector('html').classList.add('redesign');

        tracking('loaded', 'transfer');
    }

    render() {
        return (
            <div className="page-transfer">
                <DetectMultipleTabs travelType="transfer" />

                <Header />

                <HeroTeaser />

                <div className="content-wrapper">
                    <div className="intro row">
                        <h1 className="main-headline col">Transfer</h1>
                    </div>

                    <div className="row">
                        <Form />
                    </div>
                </div>

                <Footer />
            </div>
        );
    }
}

export default Index;
